import { DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI } from '../../../types/default-cloud-graph-remote-link-entity-ati';
import type { ThirdPartyConfig } from '../../../types/schemas/types';
import { TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';

import { LaunchDarklyIcon, LaunchDarklySearchResultIcon } from './icon';

export const launchDarklyConfig: ThirdPartyConfig = {
	displayName: 'LaunchDarkly',
	id: 'launchdarkly',
	resourceType: ProductResourceTypes3P.LaunchDarkly,
	icon: get3PLogo(LaunchDarklyIcon, 'LaunchDarkly', 'medium'),
	searchResultIcon: get3PLogo(LaunchDarklySearchResultIcon, 'LaunchDarkly', 'large'),
	integrationAri: 'ari:cloud:platform::integration/launchdarkly',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.WorkItem,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	requiresOauth: true,
	isEnabled: () => true,
};
